/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CalibrationDataState } from './CalibrationDataState';
import {
    instanceOfCalibrationDataState,
    CalibrationDataStateFromJSON,
    CalibrationDataStateFromJSONTyped,
    CalibrationDataStateToJSON,
} from './CalibrationDataState';

/**
 * @type CalibrationDataDtoCalibrationState
 * 
 * @export
 */
export type CalibrationDataDtoCalibrationState = CalibrationDataState;


export function CalibrationDataDtoCalibrationStateFromJSON(json: any): CalibrationDataDtoCalibrationState {
    return CalibrationDataDtoCalibrationStateFromJSONTyped(json, false);
}

export function CalibrationDataDtoCalibrationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalibrationDataDtoCalibrationState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...CalibrationDataStateFromJSONTyped(json, true) };
    return  CalibrationDataStateFromJSONTyped(json, true);
}

export function CalibrationDataDtoCalibrationStateToJSON(value?: CalibrationDataDtoCalibrationState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfCalibrationDataState(value)) {
        return CalibrationDataStateToJSON(value as CalibrationDataState);
    }

    return {};
}

/**
 * Check if a given object implements the CalibrationDataDtoCalibrationState interface.
 */
export function instanceOfCalibrationDataDtoCalibrationState(value: any): value is CalibrationDataDtoCalibrationState {
    if (instanceOfCalibrationDataState(value)) return true;
    return false;
}

